import { Division, GetScore, Lifter, Meet } from "types";
import { getPercentOfRecordEligibleRecord } from "../records";
import { getTotal } from "util/lifterHelper";
import { isLbsMeet } from "util/meetHelper";
import { toKg } from "util/conversions";

export const percentOfRecord = function (
  total: number,
  division: Division | undefined,
  lifter: Lifter,
  meet: Meet
) {
  const records = meet.records;
  const equipmentLevel = division?.rawOrEquipped;
  const gender = lifter.gender;

  if (!records || !equipmentLevel || !gender || !total || !division) {
    return 0;
  }

  const record = getPercentOfRecordEligibleRecord({ division, lifter, meet });

  if (!record || !record.recordWeight) {
    return 0;
  }
  return (total / record.recordWeight) * 100;
};

export const getPercentOfRecordPoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  if (isLbsMeet(meet)) {
    total = toKg(total);
  }

  return percentOfRecord(total, division, lifter, meet);
};
